export default [  
  /*{  //20220414 Wen modify 富邦疫苗停售 //20210530 Wen Modify Sort
    title: '疫苗險防疫險',
    subtitle: '網路投保疫苗險防疫險方便又快速!打造個人防護網! ',
    img: require('@/assets/card-vaccine.jpg'),
    desc: '保護自己的一個保障。',
    type: 'vaccine',
  },*/
  {
//20210530 Wen modify 首頁
    title: '寵物險',
    subtitle: '網路投保寵物險方便又快速!打造寶貝防護網! ',
    img: require('@/assets/card-pet.jpg'),
    desc: '保護家中寶貝寵物的一個保障。',
    type: 'pet',
  },
  {
    title: '旅平險',
    subtitle: '網路投保可享9折優惠，國內外安心出遊，玩得盡興。',
    img: require('@/assets/card-travel.jpg'),
    desc: '出門旅遊，旅平險準備好了嗎？出發前1小時也可以保，保額、方案自由選擇，3分鐘迅速完保超輕鬆！',
    type: 'travel',
  },
  {
    title: '汽車險',
    subtitle: '網路投保任意險可享9折優惠、強制險可享100元優惠',
    img: require('@/assets/card-car.jpg'),
    desc: '路上滿滿「三寶」，如何保護愛車？車險如同規劃人身保障一樣，買對車險，讓您人車皆保障。',
    type: 'car',
  },
  {
    title: '機車險',
    subtitle: '網路投保任意險可享9折優惠、強制險可享60元優惠',
    img: require('@/assets/card-motor.jpg'),
    desc: '為年輕小資族打造個人防護網，擔心車禍事故造成鉅額賠償，只有強制險還不夠，機車族必保第三人責任險。',
    type: 'motor',
  },  //2021/5/17 Wen   20210830 Wen modify 首頁
  /*{
    title: '傷害險',
    subtitle: '網路投保傷害險方便又快速!打造個人防護網! ',
    img: require('@/assets/card-accident.jpg'),
    desc: '上有高堂要奉養，下有兒女要撫養，當意外傷害突然找上門，彌補自己與家人可能面臨的生活困境，讓您暫時支付生活開銷。',
    type: 'accident',
  },*/
  
  //,
  
  // {
  //   title: '年金險',
  //   subtitle: '全方位保障，未來少煩惱',
  //   img: require('@/assets/card-money.jpg'),
  //   desc: '銀髮趨勢席捲全球，台灣成為全球老化速度最快的國家，該如何照顧好自己的樂退生活？',
  //   type: null,
  // },
];
